import AsyncStorage from '@react-native-async-storage/async-storage';

const DEVICE_ID_KEY = '@budget_device_id';

function generateId(): string {
  return `budget-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export async function getDeviceId(): Promise<string> {
  const existing = await AsyncStorage.getItem(DEVICE_ID_KEY);
  if (existing) {
    return existing;
  }
  const id = generateId();
  await AsyncStorage.setItem(DEVICE_ID_KEY, id);
  return id;
}
